import React, { useEffect, useState } from "react";
import { TextField, Grid, Autocomplete } from "@mui/material";
import { styled, Box, Button, Stack } from "@mui/material";
import { DialogTitle, SubTitle } from "./styles";
import { saveVehicleExpense } from "./httpCalls";
import { getVehicles, vehicleAdded } from "./vehicleSlice";
import { Toast } from "../components/Toast";
import { useDispatch, useSelector } from "react-redux";
import { vehicleExpenseAdded } from "./vehicleReportSlice";

const Input = styled(TextField)({
  background: "#F8F8F8 !important",
  borderRadius: "4px",
});

function AddEntry({ onClose }) {
  const dispatch = useDispatch();
  const { vehicles } = useSelector((state) => state.vehicle);
  const [state, setState] = useState({
    driverName: "",
    checkIn: 0,
  });

  useEffect(() => {
    if (vehicles.length == 0) {
      dispatch(getVehicles());
    }
  }, []);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({ ...prev, [name]: value }));
  };
  const handleDriver = (e, val) => {
    if (val) {
      setState((prev) => ({ ...prev, driverName: val }));
    } else {
      setState((prev) => ({
        ...prev,
        driverName: "",
      }));
    }
  };

  const submit = async () => {
    try {
      if (!state.driverName || !state.checkIn) {
        Toast("info", "Kindly select Vehicle and fill CheckIn");
        return;
      }
      onClose();
      // dispatch(vehicleExpenseAdded(state));
      saveVehicleExpense(state, dispatch);
    } catch (err) {
      console.log("err:", err);
      Toast("error", "Error");
    }
  };

  return (
    <Box sx={{ background: "#FFFFFF", borderRadius: "20px" }}>
      <DialogTitle>Add Driver Entry</DialogTitle>
      <Grid container spacing={2.5} marginTop="2%">
        <Grid item xs={12}>
          <Autocomplete
            onChange={(e, val) => {
              handleDriver(e, val);
            }}
            size="small"
            sx={{ background: "#F8F8F8 !important" }}
            getOptionLabel={(option) => option.driverName || ""}
            id="controllable-states-demo"
            options={vehicles}
            fullWidth
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Driver"
                variant="outlined"
                fullWidth
                sx={{ background: "#F8F8F8 !important" }}
                size="small"
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <Input
            variant="outlined"
            fullWidth
            size="small"
            type="number"
            label="Check In"
            name="checkIn"
            value={state.checkIn}
            onChange={handleInput}
          />
        </Grid>
      </Grid>
      <Stack
        width="100%"
        direction="row"
        justifyContent="space-around"
        margin="3% 0px"
      >
        <Button
          sx={{
            width: "25%",
            color: "#A7A7A7",
            background: "#F8F8F8 !important",
          }}
          variant="contained"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button sx={{ width: "25%" }} variant="contained" onClick={submit}>
          Save
        </Button>
      </Stack>
    </Box>
  );
}

export default AddEntry;
